<template>
<div class="calculation_area my-2 px-2 pb-2 ">	


<!--controls-->


<div class="calculation_controls">



<!--various_questions-->
<template v-if="$store.state.questionlists.questionlist.type=='various_questions'">
<Button label="İptal"   v-if="adding_variable || adding_operator" class=" p-button-danger p-button-outlined  p-button-sm mr-2" @click="cancelAdding"></Button>
<Button label="Yeni Değişken Ekle" v-if="!adding_variable" class=" p-button-primary p-button-outlined  p-button-sm" @click="addVariable"></Button>
<Button label="Yeni Operatör Ekle" v-if="!adding_operator" class=" p-button-primary p-button-outlined  p-button-sm ml-2" @click="addOperator"></Button>

<template v-if="adding_variable">

<Dropdown 
:filter="false"  
v-model="selectedtype" 
:options="types" 
optionLabel="name" 
optionValue="code" 
class="ml-2 p-inputtext-sm"/>


<template v-if="selectedtype">

<Dropdown 
v-if="selectedtype=='section'"
:filter="true"  
v-model="selectedinputfieldsection" 
:options="inputfieldsections" 
optionLabel="name" 
class="ml-2 p-inputtext-sm" 
@change="variableSelected"/>

<Dropdown 
v-if="selectedtype=='inputfield'"
:filter="true"  
v-model="selectedinputfield" 
:options="inputfields" 
optionLabel="name" 
class="ml-2 p-inputtext-sm"  
@change="variableSelected"/>

<Dropdown 
v-if="selectedtype=='section'"
:filter="true"  
v-model="selectedinputfieldclass" 
:options="inputfieldclasses" 
optionLabel="name" 
class="ml-2 p-inputtext-sm"  
@change="variableSelected"/>


<Dropdown 
v-if="selectedtype=='customattribute'"
:filter="true"  
v-model="selectedcustomattribute" 
:options="numerical_attributes" 
optionLabel="name" 
class="ml-2 p-inputtext-sm"  
@change="variableSelected"/>

<Dropdown 
v-if="selectedtype=='customcalculation'"
:filter="true"  
v-model="selectedcustomcalculation" 
:options="customcalculations" 
optionLabel="name" 
class="ml-2 p-inputtext-sm"  
@change="variableSelected"/>




</template>



</template>

<!--add operator-->
<template v-if="adding_operator">
<Dropdown   
v-model="selectedoperator" 
:options="operators" 
optionLabel="name" 
optionValue="code" 
class="ml-2 p-inputtext-sm" 
@change="operatorSelected"/>
</template>
<!--add operator-->




</template>
<!--various_questions-->

<!--same_question_pattern-->
<template v-if="$store.state.questionlists.questionlist.type=='same_question_pattern'">
<Button label="İptal"   v-if="adding_variable || adding_operator" class=" p-button-danger p-button-outlined  p-button-sm mr-2" @click="cancelAdding"></Button>
<Button label="Yeni Değişken Ekle" v-if="!adding_variable" class=" p-button-primary p-button-outlined  p-button-sm" @click="addVariable"></Button>

<Button label="Yeni Operatör Ekle" v-if="!adding_operator" class=" p-button-primary p-button-outlined  p-button-sm ml-2" @click="addOperator"></Button>


<Dropdown 
:filter="false"  
v-if="adding_variable"
v-model="selectedtype" 
:options="types" 
optionLabel="name" 
optionValue="code" 
class="ml-2 p-inputtext-sm"/>

<template v-if="selectedtype=='inputfield'">
<!--add variable-->
<template v-if="adding_variable">
<Dropdown 
:filter="true"  
v-model="selectedquestionlistoption" 
:options="questionlistoptions" 
optionLabel="name"  
class="ml-2 p-inputtext-sm" 
@change="variableSelected"/>
<Dropdown 
:filter="true"  
v-model="selectedinputfieldclass" 
:options="inputfieldclasses" 
optionLabel="name"  
class="ml-2 p-inputtext-sm"  
@change="variableSelected"/>

</template>
<!--add variable-->	
</template>


<Dropdown 
v-if="selectedtype=='customattribute'"
:filter="true"  
v-model="selectedcustomattribute" 
:options="numerical_attributes" 
optionLabel="name" 
class="ml-2 p-inputtext-sm"  
@change="variableSelected"/>

<Dropdown 
v-if="selectedtype=='customcalculation'"
:filter="true"  
v-model="selectedcustomcalculation" 
:options="customcalculations" 
optionLabel="name" 
class="ml-2 p-inputtext-sm"  
@change="variableSelected"/>




<!--add operator-->
<template v-if="adding_operator">
<Dropdown   v-model="selectedoperator" 
:options="operators" 
optionLabel="name" 
optionValue="code" 
class="ml-2 p-inputtext-sm" 
@change="operatorSelected"/>
</template>
<!--add operator-->

	
</template>
<!--same_question_pattern-->





</div>

<!--controls-->

<CalculationStage :nodes="$store.state.calculations.nodes" :connections="$store.state.calculations.connections"></CalculationStage>

</div>
</template>

<script>
import CalculationStage from "./CalculationStage"
 
export default {

  name: 'QuestionlistCalculationRoot',
  props:["questionlists","nodesdata","questionlistoptions","inputfieldclasses","inputfields","inputfieldsections","customattributes","customcalculations"],
  components:{CalculationStage},
  data () {
    return {
    	nodes:[],
    	connections:[],
    	node:{
				id:null,
				title:null,
				queue:null,
				inputfieldclass_id:null,
				questionlistoption_id:null,
				inputfieldsection_id:null,
				inputfield_id:null,
				customattribute_id:null,
				customcalculation_id:null,
				offsetX:10,
				offsetY:10,
				type:null,
				output:null,
				input:[],
				condition_operator:null,
				condition_action:{customattribute:null,value:null,low_point:0,high_point:0},
				input1:null,
				input2:null,
				logic_bundles:[],
			},
			connection:{
				id:null,
				x1:null,
				y1:null,
				x2:null,
				y2:null,
				from:null,
				to:null,
				drawing:true,
			},
			operators:[
				{name:"Toplama",code:"addition"},
				{name:"Çıkarma",code:"subtraction"},
				{name:"Çarpma",code:"multiplication"},
				{name:"Bölme",code:"division"},
				{name:"Eşittir",code:"equation"},
				{name:"Özel Nitelik",code:"customattribute"},
				{name:"Koşullu Veri",code:"conditional_logic"},    		
			],
			container:null,
			currentX:0,
	  	currentY:0,
	  	initialX:0,
	  	initialY:0,
	  	xOffset:0,
	  	yOffset:0,
	  	drag_active:false,
	  	draw_active:false,
	  	dragged_element:null,
	  	adding_item:false,
	  	adding_variable:false,
	  	adding_operator:false,
			selectedquestionlistoption:null,
			selectedinputfieldclass:null,
			selectedinputfieldsection:null,
			selectedinputfield:null,
			selectedcustomattribute:null,
			selectedcustomcalculation:null,
			selectedcolumn:null,
			selectedoperator:null,
			selectedtype:null,
	    columns:[],
	    loading_inputfields:false,
	    loading_columns:true,
    }
  },
  computed:{
  	numerical_attributes()
  	{
  		if(this.customattributes)
  		{
  			return this.customattributes.filter(item=>item.type=="number")
  		}
  		return []
  	},
  	types()
  	{
  		if(this.$store.state.questionlists.questionlist && this.$store.state.questionlists.questionlist.type)
  		{
  			if(this.$store.state.questionlists.questionlist.type=="various_questions")
  			{
  				return [
	  				{name:"Bölüm Puanı",code:"section"},
						{name:"Soru Puanı",code:"inputfield"},
						{name:"Özel Nitelik",code:"customattribute"},
						{name:"Özel Hesaplama",code:"customcalculation"},
					]
  			}
  			else
  			{
  				return [
						{name:"Soru Puanı",code:"inputfield"},
						{name:"Özel Nitelik",code:"customattribute"},
						{name:"Özel Hesaplama",code:"customcalculation"},
					]
  			}
  		}
  		return []
  	},
  	nodemoved()
  	{
  		return this.$store.state.calculations.nodedragging
  	},
  	connectioncreated()
  	{
  		return this.$store.state.calculations.connectioncreated
  	},
  },
  watch:{
  	nodesdata(newval)
  	{
  		console.log("nodesdata")
  		let nodesdata = JSON.parse(this.nodesdata)
  		console.log(nodesdata)
  		this.$store.dispatch('calculations/setNodes',nodesdata.nodes)
  		this.$store.dispatch('calculations/setConnections',nodesdata.connections)
  	},
  	nodemoved(newval)
  	{  		
  		if(!newval)
  		{

  		}
  	},
  	connectioncreated(newval)
  	{  		

  		if(newval)
  		{
  			console.log("connectioncreated")

  			
  		}
  	}
  },
  mounted()
  {
  	this.$store.state.calculations.stagezoom = 1
  	this.$store.dispatch('calculations/setNodes',[])
  	this.$store.dispatch('calculations/setConnections',[])
  	this.$store.dispatch('calculations/setSelectedConnection',null)
  	this.container = document.querySelector("#calculation_stage");

  	this.container.addEventListener("touchstart", this.dragStart, false);
    this.container.addEventListener("touchend", this.dragEnd, false);
    this.container.addEventListener("touchmove", this.drag, false);
    this.container.addEventListener("mouseover", this.pointerenter, false);

    
  	this.container.addEventListener("mousedown", this.dragStart, false);
    this.container.addEventListener("mouseup", this.dragEnd, false);
    this.container.addEventListener("mousemove", this.drag, false);
    this.container.addEventListener("mouseover", this.overNotch, false);
    this.container.addEventListener("wheel", this.zoomStage, false);
    
	if(this.nodesdata)
  	{
  		console.log("nodesdata")
  		let nodesdata = JSON.parse(this.nodesdata)
  		console.log(nodesdata)
  		this.$store.dispatch('calculations/setNodes',nodesdata.nodes)
  		this.$store.dispatch('calculations/setConnections',nodesdata.connections)
  	}

  	

  },
  methods:{
  	async variableSelected()
    {
    	if(this.$store.state.questionlists.questionlist.type=="same_question_pattern")
    	{
    		if(this.selectedquestionlistoption && this.selectedinputfieldclass)
    		{
    			this.addSameQuestionPatternVariableNode() 
    		}
    		if(this.selectedtype=="customattribute" && this.selectedcustomattribute)
    		{
    			this.addCustomAttributeVariableNode()
    		}
    		if(this.selectedtype=="customcalculation" && this.selectedcustomcalculation)
    		{
    			this.addCustomCalculationVariableNode()
    		}
	        		
    	}
    	if(this.$store.state.questionlists.questionlist.type=="various_questions")
    	{
    		if(this.selectedtype=="section" && this.selectedinputfieldsection && this.selectedinputfieldclass)
    		{
    			this.addVariousQuestionPatternVariableNode()
    		}
    		if(this.selectedtype=="inputfield" && this.selectedinputfield)
    		{
    			this.addVariousQuestionPatternVariableNode()
    		}
    		if(this.selectedtype=="customattribute" && this.selectedcustomattribute)
    		{
    			this.addCustomAttributeVariableNode()
    		}
    		if(this.selectedtype=="customcalculation" && this.selectedcustomcalculation)
    		{
    			this.addCustomCalculationVariableNode()
    		}
    		
    	}
      
    },
    operatorSelected()
    {
    	console.log(this.selectedoperator)
    	let operator = this.operators.find((item)=>{return item.code == this.selectedoperator})
    	let node = this.sanitizeArray(this.node)
  		node.id =  Math.floor(Date.now() / 10)
  		node.title =  Math.floor(Date.now() / 10)
  		node.offsetX = 10
  		node.offsetY = 10
  		node.title = operator.name
  		node.type=this.selectedoperator
  		
  		let nodes = this.$store.state.calculations.nodes
  		nodes.push(node)
  		this.$store.dispatch('calculations/setNodes',nodes)

        this.cancelAdding()

    },
    addCustomAttributeVariableNode()
    {
    	let node = this.sanitizeArray(this.node)
  		node.id =  Math.floor(Date.now() / 10)
  		node.title =  Math.floor(Date.now() / 10)
  		node.offsetX = 10
  		node.offsetY = 10
  		node.title = this.selectedcustomattribute.name+" değeri"
  		node.customattribute_id = this.selectedcustomattribute.id
  		node.type="customattribute_value" 				
  		let nodes = this.$store.state.calculations.nodes
  		nodes.push(node)
  		this.$store.dispatch('calculations/setNodes',nodes)
       this.cancelAdding()
    },

    addCustomCalculationVariableNode()
    {
    	let node = this.sanitizeArray(this.node)
  		node.id =  Math.floor(Date.now() / 10)
  		node.title =  Math.floor(Date.now() / 10)
  		node.offsetX = 10
  		node.offsetY = 10
  		node.title = this.selectedcustomcalculation.name+" değeri"
  		node.customcalculation_id = this.selectedcustomcalculation.id
  		node.type=this.selectedtype  				
  		let nodes = this.$store.state.calculations.nodes
  		nodes.push(node)
  		this.$store.dispatch('calculations/setNodes',nodes)
       this.cancelAdding()
    },

    addVariousQuestionPatternVariableNode()
    {
    	console.log("addVariousQuestionPatternVariableNode")
    	let the_name    	   	

    	if(this.selectedtype=="section")
    	{
    		let class_name 
    		if(this.selectedinputfieldclass.id===0 || this.selectedinputfieldclass.id=="all")
	    	{
	    		class_name = "Bütün Sınıflar"
	    	}
	    	else
	    	{
	    		class_name = this.selectedinputfieldclass.name
	    	}
    		the_name = class_name +" - "+this.selectedinputfieldsection.name+"  işaretleme toplamı"
    	}
    	if(this.selectedtype=="inputfield")
    	{
    		the_name = this.selectedinputfield.name+"  işaretleme değeri"
    	}

    	let node = this.sanitizeArray(this.node)
  		node.id =  Math.floor(Date.now() / 10)
  		node.title =  Math.floor(Date.now() / 10)
  		node.offsetX = 10
  		node.offsetY = 10
  		node.title = the_name
  		node.type=this.selectedtype
  		if(this.selectedtype=="section")
  		{
  			node.inputfieldclass_id = this.selectedinputfieldclass.id
  			node.inputfieldsection_id = this.selectedinputfieldsection.id 
  		}
  		if(this.selectedtype=="inputfield")
  		{
  			node.inputfield_id = this.selectedinputfield.id 
  		}
  				
  		let nodes = this.$store.state.calculations.nodes
  		nodes.push(node)
  		this.$store.dispatch('calculations/setNodes',nodes)
       this.cancelAdding()
    	
    	

    },
    addSameQuestionPatternVariableNode()
    {
    	let the_name
    	if(this.selectedinputfieldclass.id===0 || this.selectedinputfieldclass.id=="all")
    	{
    		if(this.selectedquestionlistoption.id=="all")
    		{
    				the_name = "Bütün Sınıflar "+this.selectedquestionlistoption.name+"  işaretleme toplamı"
    		}
    		else
    		{
    				the_name = "Bütün Sınıflar "+this.selectedquestionlistoption.name+" seçeneği işaretleme toplamı"
    		}
    		
    	}
    	else
    	{
    		if(this.selectedquestionlistoption.id=="all")
    		{
    				the_name = this.selectedinputfieldclass.name+" sınıfı "+this.selectedquestionlistoption.name+"  işaretleme toplamı"
    		}
    		else
    		{
    				the_name = this.selectedinputfieldclass.name+" sınıfı "+this.selectedquestionlistoption.name+" seçeneği işaretleme toplamı"
    		}
    		
    	}
    	let node = this.sanitizeArray(this.node)
  		node.id =  Math.floor(Date.now() / 10)
  		node.title =  Math.floor(Date.now() / 10)
  		node.offsetX = 10
  		node.offsetY = 10
  		node.title = the_name
  		node.type="variable"
  		node.inputfieldclass_id = this.selectedinputfieldclass.id
  		node.questionlistoption_id = this.selectedquestionlistoption.id 		
  		let nodes = this.$store.state.calculations.nodes
  		nodes.push(node)
  		this.$store.dispatch('calculations/setNodes',nodes)
       this.cancelAdding()
    },

    addVariable()
    {
      this.adding_variable = true
      this.adding_operator = false
    },    
    cancelAdding()
    {
      this.selectedinputfieldclass = null
      this.selectedquestionlistoption = null
      this.selectedinputfieldsection = null
      this.selectedinputfield = null
      this.selectedtype = null
      this.selectedcolumn = null
      this.adding_variable = false
      this.selectedoperator = null
      this.adding_operator = false
    },

    addOperator()
    {
      this.adding_operator = true
      this.adding_variable = false
    },    
    cancelOperator()
    {
      
    },
  	dragStart(e)
  	{
  		
  		//node drag start
  		//console.log(this.$store.state.calculations.nodes)
  		//console.log(this.$store.state.calculations.connections)
  		let zoom = this.$store.state.calculations.stagezoom
  		if(e.target.classList.contains("calculation_node_header_text"))
  		{
  			let target_id = e.target.id.replace("handle","node")
  			let node_id = e.target.id.replace("handle","")  			
      	let selected_node_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == node_id})
      	this.$store.dispatch('calculations/setSelectedNode',this.$store.state.calculations.nodes[selected_node_ind])
      	this.dragged_element = document.getElementById(target_id)  			
      	this.drag_active = true
  		}
  		//right node drag start
  		if(e.target.classList.contains("calculation_node_right_notch"))
  		{
  			let from_id = e.target.id.replace("right_notch","")
  			let bounds = this.container.getBoundingClientRect();
      	let initialX = e.clientX - bounds.left
	     	let initialY = e.clientY - bounds.top
	     	let connection = this.sanitizeArray(this.connection)
	  		connection.id =  Math.floor(Date.now() / 10)
	  		connection.x1 = (initialX)/zoom;
    		connection.y1 = (initialY)/zoom;
    		connection.x2 = (initialX)/zoom;
    		connection.y2 = (initialY)/zoom;
    		connection.from = from_id
    		let connections = this.$store.state.calculations.connections
    		connections.push(connection)
    		this.$store.dispatch('calculations/setConnections',connections)
    		this.$store.dispatch('calculations/setSelectedConnection',connection)
    		let fromnode_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == from_id})
    		//this.$store.dispatch('calculations/setFromNode',this.$store.state.calculations.nodes[fromnode_ind])




  			this.draw_active = true
  		}

  		//right node drag start

  	},
  	dragEnd(e)
  	{
        this.drag_active = false;
        if(this.draw_active)
        {
        	let selectedconnection = this.$store.state.calculations.selectedconnection
	        let connections = this.$store.state.calculations.connections
	        connections = connections.filter((item)=>{return item.id !== selectedconnection.id})
	        this.$store.dispatch('calculations/setConnections',connections)
        	this.draw_active = false;
        }
        

  	},
  	drag(e)
  	{

  		let zoom = this.$store.state.calculations.stagezoom
  		if (this.drag_active) {
  			e.preventDefault();
  			let selectednode = this.$store.state.calculations.selectednode
  			let bounds = this.container.getBoundingClientRect();
  			selectednode.offsetX = (e.clientX - bounds.left - (90*zoom))/zoom
  			selectednode.offsetY = (e.clientY - bounds.top - (18*zoom))/zoom
  			let nodes = this.$store.state.calculations.nodes
  			let ind = nodes.findIndex((item)=>{return item.id ==selectednode.id})
  			nodes[ind] = selectednode
  			this.$store.dispatch('calculations/setNodes',nodes)

  			/*
  			this.currentX = e.clientX - this.initialX;
	        this.currentY = e.clientY - this.initialY;
	        this.xOffset = this.currentX;
	        this.yOffset = this.currentY;
	        */
	        //this.setTranslate(this.currentX, this.currentY, this.dragged_element);
	        this.updateConnectionNotches(selectednode.offsetX,selectednode.offsetY,selectednode.id);

  		}
  		if (this.draw_active) 
  		{
  			let bounds = this.container.getBoundingClientRect();
  			let currentX = e.clientX - bounds.left
	        let currentY = e.clientY - bounds.top
	        let active_connection = this.$store.state.calculations.selectedconnection
      		//console.log(active_connection)
      		active_connection.x2 = (currentX)/zoom;
      		active_connection.y2 = (currentY)/zoom;
      		let connections = this.$store.state.calculations.connections
      		let ind = connections.findIndex((item)=>{return  item.id == active_connection.id})
      		connections[ind] = active_connection
      		this.$store.dispatch('calculations/setConnections',connections)
      		let from_node = this.$store.state.calculations.nodes.find((item)=>{return item.id == active_connection.from})

      		this.updateConnectionNotches(from_node.offsetX,from_node.offsetY,from_node.id);

  		}

  	},
  	setTranslate(xPos, yPos, el) {
      el.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
    },
    updateConnectionNotches(xPos,yPos,node_id)
    {
    	//let node = this.$store.state.calculations.nodes.find((item)=>{return item.id == node_id})
    	let from_connections = this.$store.state.calculations.connections.filter((item)=>{return item.from == node_id})
    	let to_connections = this.$store.state.calculations.connections.filter((item)=>{return item.to == node_id})
    	for(let con of from_connections)
    	{
    		con.x1 = xPos+193
    		con.y1 = yPos+18
    		con.drawing = false
    	}
    	for(let con of to_connections)
    	{
    		con.x2 = xPos -8
    		con.y2 = yPos +18
    		con.drawing = false
    	}
    },
    attachConnectionToNode(e,zoom,to_id,target_node)
    {
    	let element = document.getElementById(e.target.id)
			let selectedconnection = this.$store.state.calculations.selectedconnection
			let bounds = this.container.getBoundingClientRect();
			selectedconnection.x2 = (e.clientX - bounds.left +8)/zoom
			selectedconnection.y2 = (e.clientY - bounds.top +8)/zoom
			selectedconnection.to = to_id
			let connections = this.$store.state.calculations.connections
			let ind = connections.findIndex((item)=>{return item.id == selectedconnection.id})
			connections[ind] = selectedconnection
			this.$store.dispatch('calculations/setConnections',connections)

			if(!target_node.input.length)
			{
				let input_item = {connection_id:selectedconnection.id,type:"connection"}
				target_node.input.push(input_item)
			}
			else
			{
				let target_node_inputs = []

				for(let input of target_node.input )
				{
					let target_connection = connections.find(item=> item.id == input.connection_id)
					target_node_inputs.push(target_connection.from)
				}

				if(!target_node_inputs.includes(selectedconnection.from))
				{
					let input_item = {connection_id:selectedconnection.id,type:"connection"}
					target_node.input.push(input_item)
				}				
			}
			

			/*
			if(target_node.input1 && !target_node.input2)
			{
				target_node.input2 = input_item
			}

			if(!target_node.input1 && target_node.input2)
			{
				target_node.input1 = input_item
			}

			if(!target_node.input1 && !target_node.input2)
			{
				target_node.input1 = input_item
			}
			*/
			let target_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == to_id})
			this.$store.state.calculations.nodes[target_ind] = target_node			
			let from_node_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == selectedconnection.from})
			this.draw_active = false;
			

			this.updateConnectionNotches(this.$store.state.calculations.nodes[target_ind].offsetX,this.$store.state.calculations.nodes[target_ind].offsetY,this.$store.state.calculations.nodes[target_ind].id);
    },


  	overNotch(e)
  	{

  		let zoom = this.$store.state.calculations.stagezoom
  		if(e.target.classList.contains("calculation_node_left_notch") && this.draw_active)
  		{
  			let to_id = e.target.id.replace("left_notch","")

  			let target_node = this.$store.state.calculations.nodes.find((item)=>{return item.id == to_id})
  			console.log("target_node");
  			console.log(target_node);
  			let check_connections = this.$store.state.calculations.connections
  			console.log(check_connections);
  			if(target_node.input.length)
  			{
  				console.log("check inputs")
  				let new_inputs = []
  				for (let i = target_node.input.length - 1; i >= 0; i--) 
  				{
  					console.log(i)
  					let input = target_node.input[i]
  					if(input.connection_id)
  					{
  						console.log("check the_connection")
  						
  						let the_connection = check_connections.find(item=>item.id == input.connection_id)
  						if(the_connection)
  						{
  							console.log("has the_connection")
  							console.log(the_connection.id)
  							new_inputs.push(input)
  						}
  					}
  				}
  				target_node.input = new_inputs
  				console.log(target_node)
  			}

  			if(target_node.type!=="equation")
  			{
  				//if addition /multiplication
  				if(target_node.type=="addition" || target_node.type=="multiplication" || target_node.type=="conditional_logic"  )
  				{
  					this.attachConnectionToNode(e,zoom,to_id,target_node)
  				}
  				//if addition /multiplication

  				//if subtraction /division
  				if(target_node.type=="subtraction" || target_node.type=="division")
  				{
  					console.log("subtraction")
  					if(target_node.input.length==2)
	  				{
	  					console.log(target_node)
	  					this.showMessage("error",target_node.type.toUpperCase()+" hesaplama öğesine en fazla iki değişken iliştirilebilir","")
		  				let selectedconnection = this.$store.state.calculations.selectedconnection
			        let connections = this.$store.state.calculations.connections
			        connections = connections.filter((item)=>{return item.id !== selectedconnection.id})
			        this.$store.dispatch('calculations/setConnections',connections)
		        	this.draw_active = false;
	  					return  false
	  				}
	  				else
	  				{
	  					this.attachConnectionToNode(e,zoom,to_id,target_node)
	  				}
  				}
  				//if subtraction /division

  				//if subtraction 
  				if(target_node.type=="customattribute")
  				{
  					console.log("customattribute")
  					if(target_node.input.length==1)
	  				{
	  					console.log(target_node)
	  					this.showMessage("error",target_node.type.toUpperCase()+" hesaplama öğesine en fazla iki değişken iliştirilebilir","")
		  				let selectedconnection = this.$store.state.calculations.selectedconnection
			        let connections = this.$store.state.calculations.connections
			        connections = connections.filter((item)=>{return item.id !== selectedconnection.id})
			        this.$store.dispatch('calculations/setConnections',connections)
		        	this.draw_active = false;
	  					return  false
	  				}
	  				else
	  				{
	  					this.attachConnectionToNode(e,zoom,to_id,target_node)
	  				}
  				}
  				//if subtraction 

  				
  				
  			}


  			if(target_node.type=="equation")
  			{
  				if(target_node.input.length==1)
  				{
  					this.showMessage("error","Bir eşitlik öğesine en fazla bir değişken iliştirilebilir","")
  					let selectedconnection = this.$store.state.calculations.selectedconnection
		        let connections = this.$store.state.calculations.connections
		        connections = connections.filter((item)=>{return item.id !== selectedconnection.id})
		        this.$store.dispatch('calculations/setConnections',connections)
	        	this.draw_active = false;
  					return  false
  				}
  				else
  				{
  					this.attachConnectionToNode(e,zoom,to_id,target_node)
  				}
  				
  			}

  			

  			

  			
  		}
  		
  	},
  	zoomStage(e)
  	{
  		
  		e.preventDefault()
  		if(this.$store.state.calculations.stagezoom<1.5 && this.$store.state.calculations.stagezoom>0.5)
	  	{
	  		if(e.deltaY<0)
	  		{
	  			this.$store.state.calculations.stagezoom += 0.1
	  		}
	  		if(e.deltaY>0)
	  		{
	  			this.$store.state.calculations.stagezoom -= 0.1
	  		}
  		}
  		if(this.$store.state.calculations.stagezoom>1.5)
  		{
  			if(e.deltaY>0)
	  		{
	  			this.$store.state.calculations.stagezoom -= 0.1
	  		}
  		}

  		if(this.$store.state.calculations.stagezoom<0.5)
  		{
  			if(e.deltaY<0)
	  		{
	  			this.$store.state.calculations.stagezoom += 0.1
	  		}
  		}
  		

  	}
  }
}
</script>

<style lang="css" scoped>
</style>